import React from 'react';

import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

import { SubSubNavBarProps } from './types';
import SubSubNavBarMobile from './Mobile';
import SubSubNavBarDesktop from './Desktop';

export class SubSubNavBar extends React.Component<SubSubNavBarProps> {
  render() {
    const { isMobile } = this.props;

    return (
      <ErrorBoundary hideOnFail>
        {isMobile ? (
          <SubSubNavBarMobile {...this.props} />
        ) : (
          <SubSubNavBarDesktop {...this.props} />
        )}
      </ErrorBoundary>
    );
  }
}

export default withMobileContext(SubSubNavBar);
